@use "../../../style/utils";

@mixin align-button-to-icon($width, $font-size) {
  &:has(:global .material-icons:only-child),
  &:has(:global svg:only-child) {
    justify-content: center;
    padding: 0;
    width: $width;
  }

  & :global .material-icons {
    font-size: $font-size;
  }
}

.rounded-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;

  font-family: var(--font-stack);
  font-size: 0.75rem;
  white-space: nowrap;

  border: 1px solid var(--color-bg-subtle);
  background-color: var(--color-bg-primary);
  border-radius: 50vh;
  color: var(--color-text-primary);;

  user-select: none;
  cursor: pointer;

  &.selected {
    background-color: var(--color-bg-invert);
    color: var(--input-placeholder, #99A0A8);
  }

  &:active, &.active {
    border: 1px solid var(--color-border-primary-focus);
  }

  cursor: pointer;

  &:hover {
    // border: 1px solid var(--mm-gray-3);
    background-color: var(--color-bg-primary-hover);
    transform: scale(1.15); // Grow by 15% when hovered
    transition: transform 0.3s ease-in-out, background-color 0.3s ease-in-out;
  }

  @include utils.figma-font-weight-fix;

  &--small {
    height: 1.5rem;
    padding: 0 0.5rem;

    @include align-button-to-icon(1.5rem, 1rem);
  }

  &--medium {
    height: 1.75rem;
    padding: 0 0.5rem;

    @include align-button-to-icon(1.75rem, 1.25rem);
  }

  &--large {
    height: 2rem;
    padding: 0 0.5rem;

    @include align-button-to-icon(2rem, 1.25rem);
  }
}
